import { createStyles } from 'antd-style';

import {
  INPUT_BASE_HEIGHT,
  ThemeColors,
  ThemeFont,
  ThemeSpaces,
  hexToRgbaWithAlpha,
} from '../../../theme';
import { responsiveXsVsSm } from '../../../styles/responsiveMixins';
import { flexCenter } from '../../../styles/mixins';

export const usePackageListSummaryStyles = createStyles(({ token }) => ({
  newShipmentPackagesSummary: {
    padding: ThemeSpaces.SPACE_NORM,
  },
  newShipmentPackagesSummaryBadge: {
    ...flexCenter(),
    height: INPUT_BASE_HEIGHT,
    backgroundColor: ThemeColors.COLOR_WHITE2,
    boxShadow: `0 1px 0 ${hexToRgbaWithAlpha(ThemeColors.COLOR_GREY_BLUISH, 0.25)}, 1px 1px 6px ${ThemeColors.COLOR_GREY8_1}`,
    borderRadius: token.borderRadius,
    color: token.colorPrimary,
    fontSize: token.fontSizeHeading4,
    fontWeight: 500,
    whiteSpace: 'nowrap',

    ...responsiveXsVsSm({ width: 77 }, { width: 90 }),
  },
  newShipmentPackagesSummaryLabel: {
    color: ThemeColors.COLOR_GREY_BLUISH2,
    fontSize: token.fontSizeLG,
    fontWeight: 'bold',
    fontFamily: ThemeFont.FONT_CONDENSED,
    marginBottom: ThemeSpaces.SPACE_NORM0_5,

    ...responsiveXsVsSm(
      { fontSize: ThemeFont.FONT_SIZE_LG_MINUS },
      { fontSize: token.fontSizeLG }
    ),
  },
}));
